'use strict';

const _=require('pulsar-utils/dist-es6/_');let

FatigueDistributionIterableExtensions=class FatigueDistributionIterableExtensions{
constructor(self){
this._self=self;
}

aggregate(fatigueDistributionParameters){
for(let fatigueDistribution of this._self){
fatigueDistributionParameters.checkDistributionsConformity(fatigueDistribution);
}

let aggregatedBins=[];
aggregatedBins.length=fatigueDistributionParameters.totalBins;

for(let i=0;i<aggregatedBins.length;i++){
aggregatedBins[i]=[];

for(let fatigueDistribution of this._self){
_.pushMany(aggregatedBins[i],fatigueDistribution.bins[i]);
}
}

return{
binSize:fatigueDistributionParameters.binSize,
start:fatigueDistributionParameters.firstBinStart,
bins:aggregatedBins};

}

static extend(self){
return new FatigueDistributionIterableExtensions(self);
}};


module.exports=FatigueDistributionIterableExtensions.extend;
//# sourceMappingURL=fatigueDistributionIterableExtensions.js.map
